export default "__VITE_ASSET__EO2Xl2n2__"